import { render, staticRenderFns } from "./Dog-breeds-search.vue?vue&type=template&id=9cb432ea&scoped=true&"
import script from "./Dog-breeds-search.vue?vue&type=script&lang=js&"
export * from "./Dog-breeds-search.vue?vue&type=script&lang=js&"
import style0 from "./Dog-breeds-search.vue?vue&type=style&index=0&id=9cb432ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb432ea",
  null
  
)

export default component.exports